import ContactForm from "../components/ContactUs/ContactForm";
import ContactInfo from "../components/ContactUs/ContactInfo";
import HeroSection from "../components/HeroSection";
import Map from "../components/ContactUs/Map";

import { FaLongArrowAltRight } from "react-icons/fa";

import contactUsStyles from "../styles/ContactUs/ContactUs.module.css";
// import DottedMap from "../components/ContactUs/DottedMap";

const ContactUs = () => {

    return (
        <>
            <HeroSection
                image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFGp2qZYdVoJdQZEGdnuD3nM-yPY4Agdp2twBxbiATxIAUngU&s"
                title="Get in Touch with Greenworks"
                description="Let’s work together to create a sustainable future — reach out to GreenWorks today."
            />
            <div className={contactUsStyles.container}>
                <ContactInfo />
                <ContactForm />
            </div>
            <div 
  style={{
    display:'flex',
    gap:'40px',
    padding:"40px",
    backgroundColor:'rgb(0, 40, 85)',
    objectFit:'cover',
    backgroundSize:'cover',
    marginBottom:'30px',
    flexWrap:'wrap',
  }}
>
  <div style={{ flex: "1 1 400px", minWidth:"300px", height:'350px' }}>
    <Map />
  </div>

  <div 
    style={{
      flex: "1 1 400px",
      minWidth:"300px",
      display:'flex',
      flexDirection:'column',
      alignItems:'flex-start',
      justifyContent:'center',
      textAlign:'justify'
    }}
  >
    <div>
      <div style={{display:'flex',gap:'10px',alignItems:'center',color:'white',fontWeight:'bold'}}>
        <div 
          style={{
            width: '10px',
            height: '10px',
            backgroundColor: '#fff',
            borderRadius: '50%',
          }}
        />
        FIND US
      </div>
      <h2 style={{color:'white',textAlign:'justify',margin:0,fontWeight:400,fontSize:'18px',marginTop:'10px'}}>
        Come visit us at GreenWork Consulting — where innovation meets sustainability. Our office is situated in a vibrant, accessible location, ready to welcome clients, partners, and collaborators.
      </h2>
    </div>
    <div>
      <button
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          padding: '5px 5px 5px 20px',
          backgroundColor: '#fff',
          border: 'none',
          borderRadius: '20px',
          color: '#1a3055',
          cursor: 'pointer',
          marginTop: '20px'
        }}
        onClick={() =>
          window.open(
            'https://www.google.com/maps/search/?api=1&query=New+Delhi,+India',
            '_blank'
          )
        }
      >
        Find The Direction 
        <span 
          style={{ 
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            width:'30px',
            height:'30px',
            backgroundColor:'#1a3055',
            borderRadius:'50%'
          }} 
        >
          <FaLongArrowAltRight style={{ color:'white' }} />
        </span>
      </button>
    </div>
  </div>
</div>

        </>
    )

}

export default ContactUs;